import React from 'react'

const RedoWhiteSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 18.828 19.692'
    >
      <path
        id='redo-svgrepo-com'
        d='M15.805,13.14l-.23-2.633,3.138-.275A6.607,6.607,0,1,0,19.8,18.39l2.647.662A9.253,9.253,0,1,1,20.7,8.485l-.324-3.7,2.633-.23.691,7.9Z'
        transform='translate(-4.877 -4.55)'
        fill='#fff'
      />
    </svg>
  )
}

export default RedoWhiteSvg
